import React from 'react';
import { useTheme, styled } from '@mui/material/styles';
import { Typography, Button } from '@mui/material';
import parsePhoneNumber from 'libphonenumber-js';


const RowButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    borderRadius: 0,
    height: '65px',
    width: '100%',
    alignItems: 'center',
    alignSelf: 'center',
    background: 'transparent',
    fontWeight: 'bold',
    fontSize: '0.85rem',
    padding: 0,
    boxShadow: `inset 0px 0px 20px 0px ${theme.palette.shadow[2]}, 0px 0px 12px -2px ${theme.palette.shadow[0]}`,
    background: theme.palette.gradient.b,
    '&:hover, &.Mui-focusVisible': {

        color: theme.palette.successColor.main,
        outline: 'none',

        boxShadow: `inset 0px 0px 18px -2px ${theme.palette.buttonGlow[1]}`,

    },

}));



export const WhatAppConversationButton = ({ messageData, index, selectedChat, setSelectedChat }) => {


    const theme = useTheme();

    const phoneNumber = `+${messageData?.conversation}`;
    const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'RU');
    let countryFlagSet = true;
    if (!parsedPhoneNumber) {
        countryFlagSet = false;
    }
    const latestMessage = messageData?.messages.sort((a, b) => new Date(b.date) - new Date(a.date))[0];
    const latestMessageTime = new Date(latestMessage?.date);
    const parseLatestMessageTime = latestMessageTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    return (
        (<RowButton
            onClick={() => setSelectedChat(index)}
            sx={{ color: selectedChat === index ? 'lightgreen' : 'white' }}>
            <div className='ChatButtonRow'>

                <div className='ChatButtonLeft'>

                    <div style={{ gap: '0.5rem', display: 'flex', flexDirection: 'row' }}>
                        {countryFlagSet ?
                            <>
                                <span className={`fi fi-${parsedPhoneNumber?.country?.toLowerCase()}`}></span>
                                <Typography>{`+${parsedPhoneNumber?.countryCallingCode}`}</Typography>
                                <Typography>{parsedPhoneNumber?.nationalNumber}</Typography>
                            </>
                            :
                            <Typography>{phoneNumber}</Typography>}
                    </div>
                    <div style={{ width: '100%', position: 'relative', textOverflow: 'ellipsis' }}>
                        {latestMessage?.message?.type.toUpperCase() === 'TEXT' &&
                            <p style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'row', margin: 0, padding: 0, color: theme.palette.text.secondary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {`${latestMessage?.message?.text}`}
                            </p>}
                        {latestMessage?.message?.type.toUpperCase() === 'IMAGE' &&
                            <p style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'row', margin: 0, padding: 0, color: theme.palette.text.secondary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {`${latestMessage?.message?.caption || 'Image'}`}
                            </p>}
                    </div>


                </div>
                <div className='ChatButtonRight'>

                    <Typography sx={{}}>
                        {parseLatestMessageTime}
                    </Typography>
                </div>



            </div>
        </RowButton>));
};
